import React from "react";
import { Badge } from "@mantine/core";
import SegmentStatusBadgeStyles from "../assets/SegmentStatusBadgeStyles";

type SegmentStatusBadgeProps = {
  isActive: boolean;
};

const SegmentStatusBadge: React.FC<SegmentStatusBadgeProps> = ({
  isActive,
}) => {
  const { classes, cx } = SegmentStatusBadgeStyles();

  const statusClass = isActive ? classes.active : classes.inactive;
  const statusLabel = isActive ? "Currently in use" : "Not in use";

  return (
    <Badge
      size="sm"
      variant="filled"
      className={cx(classes.label, statusClass)}
    >
      {statusLabel}
    </Badge>
  );
};

export default SegmentStatusBadge;
